import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// SEO data for each page
const seoData = {
  '/': {
    title: 'Hand Surgeon Melbourne FL | Board Certified Hand Specialists | Melbourne Hand Center',
    description: 'Board certified hand surgeons in Melbourne, FL. Dr. Moyles & Dr. Frye specialize in carpal tunnel, wrist fractures, trigger finger, and hand surgery. Serving Palm Bay, Viera, Rockledge & Brevard County. Call 321-500-4263.',
    keywords: 'hand surgeon melbourne fl, hand surgeon palm bay, hand surgeon viera, carpal tunnel syndrome, wrist fractures, hand surgery, board certified hand surgeon, orthopedic hand specialist brevard county'
  },
  '/treatment-areas': {
    title: 'Hand & Wrist Conditions We Treat | Melbourne Hand Center',
    description: 'Expert treatment for carpal tunnel syndrome, wrist fractures, trigger finger, ganglion cysts, cubital tunnel, hand fractures & more. Fellowship-trained hand surgeons in Melbourne FL.',
    keywords: 'carpal tunnel treatment melbourne fl, wrist fracture treatment, trigger finger surgery, ganglion cyst removal, hand conditions, wrist conditions, elbow conditions'
  },
  '/doctors': {
    title: 'Meet Our Hand Surgeons | Dr. Moyles & Dr. Frye | Melbourne Hand Center',
    description: 'Dr. Kyle Moyles MD MBA & Dr. Brandon Frye DO - Fellowship-trained, board certified orthopedic hand surgeons serving Melbourne, Palm Bay, Viera & Brevard County FL.',
    keywords: 'Dr. Kyle Moyles, Dr. Brandon Frye, hand surgeon melbourne fl, orthopedic hand surgeon, board certified hand surgeon, fellowship trained hand surgeon'
  },
  '/patient-resources': {
    title: 'Patient Resources | Forms, Insurance & Telemedicine | Melbourne Hand Center',
    description: 'New patient forms, insurance information, telemedicine appointments & patient resources. Melbourne Hand Center accepts most major insurance plans. Call 321-500-4263.',
    keywords: 'patient forms, insurance accepted, telemedicine hand surgeon, virtual consultation, hand surgery preparation, medicare hand surgeon'
  },
  '/contact': {
    title: 'Contact Us | Schedule Appointment | Melbourne Hand Center',
    description: 'Contact Melbourne Hand Center at 321-500-4263. Located at 2010 W. Eau Gallie Blvd, Suite 104, Melbourne FL 32935. Same-day appointments available.',
    keywords: 'contact hand surgeon, schedule appointment, melbourne hand center location, hand surgeon near me, hand surgery consultation'
  },
  // Treatment area pages
  '/treatment-areas/carpal-tunnel-syndrome': {
    title: 'Carpal Tunnel Syndrome Treatment Melbourne FL | Hand Surgeon',
    description: 'Expert carpal tunnel syndrome treatment in Melbourne FL. Minimally invasive carpal tunnel release surgery. Fellowship-trained hand surgeons. Call 321-500-4263.',
    keywords: 'carpal tunnel syndrome, carpal tunnel treatment melbourne fl, carpal tunnel surgery, carpal tunnel release, numbness in hands, tingling fingers'
  },
  '/treatment-areas/cubital-tunnel-syndrome': {
    title: 'Cubital Tunnel Syndrome Treatment Melbourne FL | Elbow Surgeon',
    description: 'Cubital tunnel syndrome treatment by board certified surgeons in Melbourne FL. Ulnar nerve compression treatment. Call 321-500-4263.',
    keywords: 'cubital tunnel syndrome, ulnar nerve, elbow pain, numbness ring finger, elbow surgeon melbourne fl'
  },
  '/treatment-areas/wrist-fractures': {
    title: 'Wrist Fracture Treatment Melbourne FL | Hand Surgeon',
    description: 'Expert wrist fracture treatment in Melbourne FL. Broken wrist surgery, casting, and rehabilitation. Board certified hand surgeons. Call 321-500-4263.',
    keywords: 'wrist fractures, broken wrist, wrist fracture surgery, distal radius fracture, wrist surgeon melbourne fl'
  },
  '/treatment-areas/trigger-finger': {
    title: 'Trigger Finger Treatment Melbourne FL | Hand Surgeon',
    description: 'Trigger finger release surgery in Melbourne FL. Expert treatment for finger locking and catching. Fellowship-trained hand surgeons. Call 321-500-4263.',
    keywords: 'trigger finger, trigger finger release, finger locking, finger surgery melbourne fl'
  },
  '/treatment-areas/ganglion-cyst': {
    title: 'Ganglion Cyst Removal Melbourne FL | Hand Surgeon',
    description: 'Ganglion cyst removal and treatment in Melbourne FL. Expert hand surgeons for wrist and hand cysts. Call 321-500-4263.',
    keywords: 'ganglion cyst, ganglion cyst removal, wrist cyst, hand cyst, cyst surgery melbourne fl'
  },
  '/treatment-areas/dupuytrens-contractures': {
    title: "Dupuytren's Contracture Treatment Melbourne FL | Hand Surgeon",
    description: "Expert Dupuytren's contracture treatment in Melbourne FL. Needle aponeurotomy and surgical options. Board certified hand surgeons. Call 321-500-4263.",
    keywords: "dupuytren's contracture, dupuytren's disease, finger contracture, palm nodules, hand surgery melbourne fl"
  },
  '/treatment-areas/hand-fractures': {
    title: 'Hand Fracture Treatment Melbourne FL | Hand Surgeon',
    description: 'Expert hand fracture treatment in Melbourne FL. Metacarpal fracture surgery and care. Board certified hand surgeons. Call 321-500-4263.',
    keywords: 'hand fractures, broken hand, metacarpal fracture, hand fracture surgery, hand surgeon melbourne fl'
  },
  '/treatment-areas/finger-fractures': {
    title: 'Finger Fracture Treatment Melbourne FL | Hand Surgeon',
    description: 'Expert finger fracture treatment in Melbourne FL. Broken finger surgery and splinting. Fellowship-trained hand surgeons. Call 321-500-4263.',
    keywords: 'finger fractures, broken finger, phalanx fracture, finger surgery melbourne fl'
  },
  '/treatment-areas/finger-dislocations': {
    title: 'Finger Dislocation Treatment Melbourne FL | Hand Surgeon',
    description: 'Expert finger dislocation treatment in Melbourne FL. Joint reduction and rehabilitation. Board certified hand surgeons. Call 321-500-4263.',
    keywords: 'finger dislocation, dislocated finger, finger joint injury, finger surgery melbourne fl'
  },
  '/treatment-areas/finger-sprains': {
    title: 'Finger Sprain Treatment Melbourne FL | Hand Surgeon',
    description: 'Expert finger sprain treatment in Melbourne FL. Ligament injury care and rehabilitation. Hand specialists. Call 321-500-4263.',
    keywords: 'finger sprain, sprained finger, finger ligament injury, jammed finger, hand surgeon melbourne fl'
  },
  '/treatment-areas/wrist-sprains': {
    title: 'Wrist Sprain Treatment Melbourne FL | Hand Surgeon',
    description: 'Expert wrist sprain treatment in Melbourne FL. Ligament injury diagnosis and care. Board certified hand surgeons. Call 321-500-4263.',
    keywords: 'wrist sprain, sprained wrist, wrist ligament injury, wrist pain, hand surgeon melbourne fl'
  },
  '/treatment-areas/mallet-finger': {
    title: 'Mallet Finger Treatment Melbourne FL | Hand Surgeon',
    description: 'Expert mallet finger treatment in Melbourne FL. Extensor tendon injury care. Fellowship-trained hand surgeons. Call 321-500-4263.',
    keywords: 'mallet finger, baseball finger, drooping fingertip, extensor tendon injury, hand surgeon melbourne fl'
  },
  '/treatment-areas/dequervains-tenosynovitis': {
    title: "de Quervain's Tenosynovitis Treatment Melbourne FL | Hand Surgeon",
    description: "Expert de Quervain's tenosynovitis treatment in Melbourne FL. Thumb tendon pain relief. Board certified hand surgeons. Call 321-500-4263.",
    keywords: "de quervain's tenosynovitis, thumb pain, wrist pain, tendonitis, hand surgeon melbourne fl"
  },
  '/accessibility': {
    title: "Accessibility Statement | Melbourne Hand Center",
    description: "Melbourne Hand Center is committed to ensuring digital accessibility for people with disabilities. Learn about our WCAG 2.1 compliance efforts.",
    keywords: "accessibility, ada compliance, wcag, website accessibility, disability access"
  },
  '/areas-we-serve': {
    title: 'Areas We Serve | Hand & Wrist Specialists in Brevard County, FL | Melbourne Hand Center',
    description: 'Melbourne Hand Center serves patients across Brevard County, FL — Melbourne, Palm Bay, Viera, Titusville, Cocoa, Rockledge, Merritt Island, Cocoa Beach & more. Board-certified hand surgeons. Call 321-500-4263.',
    keywords: 'areas we serve, hand surgeon brevard county, hand specialist melbourne fl, palm bay hand surgeon, viera hand surgeon, titusville hand surgeon, cocoa hand surgeon, space coast hand surgeon'
  }
};

// Dynamic SEO data builder for city/area pages — generates unique titles per city
import { areasServed } from '@/data/areasServed';
areasServed.forEach((area) => {
  seoData[`/areas-we-serve/${area.slug}`] = {
    title: `Hand & Wrist Specialist in ${area.name}, FL | Melbourne Hand Center`,
    description: `Specialized hand, wrist, and elbow care for ${area.name}, FL residents. Board-certified, fellowship-trained surgeons offering carpal tunnel, trigger finger, fracture care, arthritis & nerve injury treatment. Call 321-500-4263.`,
    keywords: `hand surgeon ${area.name.toLowerCase()} fl, hand specialist ${area.name.toLowerCase()}, wrist specialist ${area.name.toLowerCase()}, carpal tunnel ${area.name.toLowerCase()}, hand surgery ${area.name.toLowerCase()} florida, brevard county hand surgeon`
  };
});

export const SEOHead = () => {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    const seo = seoData[path] || seoData['/'];
    
    // Update document title
    document.title = seo.title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', seo.description);
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', seo.keywords);
    }
    
    // Update Open Graph tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', seo.title);
    }
    
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', seo.description);
    }
    
    // Update Twitter tags
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', seo.title);
    }
    
    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', seo.description);
    }
    
    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `https://www.melbournehandcenter.com${path === '/' ? '' : path}`);
    }
    
  }, [location]);
  
  return null;
};

export default SEOHead;
